import type { FC } from "react";
import React from "react";
import { Body, Box, Flex } from "@edreamsodigeo/prisma-design-system";
import { useBrand } from "@edreamsodigeo/frontend-core";

import FlightsBannerItem from "~/components/acquisition/RefundableFlightsBanner/FlightsBannerItem";
import type { FlightsBannerContentProps } from "~/components/acquisition/RefundableFlightsBanner/contracts";

const FlightsBannerContent: FC<FlightsBannerContentProps> = ({ content }) => {
  const brand = useBrand();
  return (
    <Box backgroundColor={"neutral.0"}>
      <Flex
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        px={"1x_big"}
        pt={"big"}
        pb={"base"}
      >
        <Flex pb={"2x_small"}>
          <Body type={"base"} textAlign={"center"}>
            {content.mainTitle}
          </Body>
        </Flex>
        <Flex
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"100%"}
          pt={"base"}
        >
          {content.items.map((item, index) => (
            <FlightsBannerItem
              text={item.text}
              imageLink={item.image[brand].src}
              imageAlt={item.image.alt}
              pill={item.pill ? item.pill : undefined}
              key={index}
            />
          ))}
        </Flex>
      </Flex>
    </Box>
  );
};

export default FlightsBannerContent;
